// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2017 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

:root {
  --theia-private-file-dialog-input-height: 21px;
  --theia-private-location-list-panel-left: 92px;
  --theia-private-location-list-panel-width: 407px;
  --theia-private-navigation-panel-icon-size: 21px;
  --theia-private-navigation-panel-line-height: 23px;
}

/*
  * Open and Save file dialogs
  */

.dialogContent .theia-FileDialog,
.dialogContent .theia-SaveFileDialog,
.dialogContent .theia-ResponsiveFileDialog {
  height: 500px;
  width: 500px;
  border: 1px solid var(--theia-editorWidget-border);
  background: var(--theia-dropdown-background);
}

@media only screen and (max-height: 700px) {
  .dialogContent .theia-FileDialog,
  .dialogContent .theia-SaveFileDialog,
  .dialogContent .theia-ResponsiveFileDialog {
    height: 300px;
  }
}

.dialogContent .theia-NavigationPanel,
.dialogContent .theia-FiltersPanel,
.dialogContent .theia-FileNamePanel {
  display: block;
  position: relative;
  overflow: hidden;
}

.dialogContent .theia-NavigationPanel,
.dialogContent .theia-FiltersPanel {
  min-height: 27px;
}

.dialogContent .theia-FileNamePanel {
  height: 31px;
}

/*
 * Navigation panel items
 */

.dialogContent .theia-NavigationPanel span {
  position: absolute;
  top: 2px;
  line-height: var(--theia-private-navigation-panel-line-height);
  cursor: pointer;
  width: var(--theia-private-navigation-panel-icon-size);
  text-align: center;
}

.dialogContent .theia-NavigationPanel span:focus {
  outline: none;
  box-shadow: none;
}

.dialogContent .theia-NavigationPanel span:focus-visible {
  outline-width: 1px;
  outline-style: solid;
  outline-offset: -1px;
  opacity: 1 !important;
  outline-color: var(--theia-focusBorder);
}

.dialogContent span.theia-mod-disabled {
  pointer-events: none;
  cursor: default;
}

.dialogContent span.theia-mod-disabled .action-label {
  background: none;
}

.dialogContent .theia-NavigationBack {
  left: auto;
}

.dialogContent .theia-NavigationForward {
  left: 23px;
}

.dialogContent .theia-NavigationHome {
  left: 45px;
}

.dialogContent .theia-NavigationUp {
  left: 67px;
}

.dialogContent .theia-LocationListPanel {
  position: absolute;
  display: flex;
  top: 1px;
  left: var(--theia-private-location-list-panel-left);
  width: var(--theia-private-location-list-panel-width);
  height: var(--theia-private-file-dialog-input-height);
}

.dialogContent .theia-LocationInputToggle {
  text-align: center;
  left: 0;
  width: var(--theia-private-navigation-panel-icon-size);
  height: var(--theia-private-navigation-panel-icon-size);
  z-index: 1;
}

.dialogContent .theia-LocationList,
.dialogContent .theia-LocationTextInput {
  box-sizing: content-box;
  padding: unset;
  position: absolute;
  top: 0;
  left: 0;
  height: var(--theia-private-file-dialog-input-height);
  border: var(--theia-border-width) solid var(--theia-input-border);
}

.dialogContent .theia-LocationList,
.dialogContent .theia-LocationTextInput {
  padding-left: var(--theia-private-navigation-panel-icon-size);
  width: calc(100% - var(--theia-private-navigation-panel-icon-size));
}

/*
 * Filters panel items
 */

.dialogContent .theia-FiltersLabel {
  position: absolute;
  left: 1px;
  top: 0px;
  line-height: 27px;
}

.dialogContent .theia-FiltersListPanel {
  position: absolute;
  left: 72px;
  top: 3px;
}

.dialogContent .theia-FileTreeFiltersList {
  width: 427px;
  height: var(--theia-private-file-dialog-input-height);
}

/*
 * File name panel items
 */

.dialogContent .theia-FileNameLabel {
  position: absolute;
  left: 1px;
  top: 0px;
  line-height: 23px;
}

.dialogContent .theia-FileNameTextField {
  position: absolute;
  left: 72px;
  top: 0px;
  width: 420px;
}

/*
 * Control panel items
 */

.dialogContent .theia-ControlPanel {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: 0px;
}

.dialogContent .theia-ControlPanel > * {
  margin-left: 4px;
}

.dialogContent .theia-ToggleHiddenInputContainer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: var(--theia-ui-padding);
}
`, "",{"version":3,"sources":["webpack://./../node_modules/@theia/filesystem/src/browser/style/file-dialog.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,8CAA8C;EAC9C,8CAA8C;EAC9C,gDAAgD;EAChD,gDAAgD;EAChD,kDAAkD;AACpD;;AAEA;;GAEG;;AAEH;;;EAGE,aAAa;EACb,YAAY;EACZ,kDAAkD;EAClD,4CAA4C;AAC9C;;AAEA;EACE;;;IAGE,aAAa;EACf;AACF;;AAEA;;;EAGE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE;;AAEF;EACE,kBAAkB;EAClB,QAAQ;EACR,8DAA8D;EAC9D,eAAe;EACf,sDAAsD;EACtD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,mDAAmD;EACnD,qDAAqD;EACrD,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,sDAAsD;EACtD,uDAAuD;EACvD,UAAU;AACZ;;AAEA;;EAEE,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,qDAAqD;EACrD,iEAAiE;AACnE;;AAEA;;EAEE,6DAA6D;EAC7D,mEAAmE;AACrE;;AAEA;;EAEE;;AAEF;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,qDAAqD;AACvD;;AAEA;;EAEE;;AAEF;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;;EAEE;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,oCAAoC;AACtC","sourcesContent":["/********************************************************************************\n * Copyright (C) 2017 TypeFox and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n:root {\n  --theia-private-file-dialog-input-height: 21px;\n  --theia-private-location-list-panel-left: 92px;\n  --theia-private-location-list-panel-width: 407px;\n  --theia-private-navigation-panel-icon-size: 21px;\n  --theia-private-navigation-panel-line-height: 23px;\n}\n\n/*\n  * Open and Save file dialogs\n  */\n\n.dialogContent .theia-FileDialog,\n.dialogContent .theia-SaveFileDialog,\n.dialogContent .theia-ResponsiveFileDialog {\n  height: 500px;\n  width: 500px;\n  border: 1px solid var(--theia-editorWidget-border);\n  background: var(--theia-dropdown-background);\n}\n\n@media only screen and (max-height: 700px) {\n  .dialogContent .theia-FileDialog,\n  .dialogContent .theia-SaveFileDialog,\n  .dialogContent .theia-ResponsiveFileDialog {\n    height: 300px;\n  }\n}\n\n.dialogContent .theia-NavigationPanel,\n.dialogContent .theia-FiltersPanel,\n.dialogContent .theia-FileNamePanel {\n  display: block;\n  position: relative;\n  overflow: hidden;\n}\n\n.dialogContent .theia-NavigationPanel,\n.dialogContent .theia-FiltersPanel {\n  min-height: 27px;\n}\n\n.dialogContent .theia-FileNamePanel {\n  height: 31px;\n}\n\n/*\n * Navigation panel items\n */\n\n.dialogContent .theia-NavigationPanel span {\n  position: absolute;\n  top: 2px;\n  line-height: var(--theia-private-navigation-panel-line-height);\n  cursor: pointer;\n  width: var(--theia-private-navigation-panel-icon-size);\n  text-align: center;\n}\n\n.dialogContent .theia-NavigationPanel span:focus {\n  outline: none;\n  box-shadow: none;\n}\n\n.dialogContent .theia-NavigationPanel span:focus-visible {\n  outline-width: 1px;\n  outline-style: solid;\n  outline-offset: -1px;\n  opacity: 1 !important;\n  outline-color: var(--theia-focusBorder);\n}\n\n.dialogContent span.theia-mod-disabled {\n  pointer-events: none;\n  cursor: default;\n}\n\n.dialogContent span.theia-mod-disabled .action-label {\n  background: none;\n}\n\n.dialogContent .theia-NavigationBack {\n  left: auto;\n}\n\n.dialogContent .theia-NavigationForward {\n  left: 23px;\n}\n\n.dialogContent .theia-NavigationHome {\n  left: 45px;\n}\n\n.dialogContent .theia-NavigationUp {\n  left: 67px;\n}\n\n.dialogContent .theia-LocationListPanel {\n  position: absolute;\n  display: flex;\n  top: 1px;\n  left: var(--theia-private-location-list-panel-left);\n  width: var(--theia-private-location-list-panel-width);\n  height: var(--theia-private-file-dialog-input-height);\n}\n\n.dialogContent .theia-LocationInputToggle {\n  text-align: center;\n  left: 0;\n  width: var(--theia-private-navigation-panel-icon-size);\n  height: var(--theia-private-navigation-panel-icon-size);\n  z-index: 1;\n}\n\n.dialogContent .theia-LocationList,\n.dialogContent .theia-LocationTextInput {\n  box-sizing: content-box;\n  padding: unset;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: var(--theia-private-file-dialog-input-height);\n  border: var(--theia-border-width) solid var(--theia-input-border);\n}\n\n.dialogContent .theia-LocationList,\n.dialogContent .theia-LocationTextInput {\n  padding-left: var(--theia-private-navigation-panel-icon-size);\n  width: calc(100% - var(--theia-private-navigation-panel-icon-size));\n}\n\n/*\n * Filters panel items\n */\n\n.dialogContent .theia-FiltersLabel {\n  position: absolute;\n  left: 1px;\n  top: 0px;\n  line-height: 27px;\n}\n\n.dialogContent .theia-FiltersListPanel {\n  position: absolute;\n  left: 72px;\n  top: 3px;\n}\n\n.dialogContent .theia-FileTreeFiltersList {\n  width: 427px;\n  height: var(--theia-private-file-dialog-input-height);\n}\n\n/*\n * File name panel items\n */\n\n.dialogContent .theia-FileNameLabel {\n  position: absolute;\n  left: 1px;\n  top: 0px;\n  line-height: 23px;\n}\n\n.dialogContent .theia-FileNameTextField {\n  position: absolute;\n  left: 72px;\n  top: 0px;\n  width: 420px;\n}\n\n/*\n * Control panel items\n */\n\n.dialogContent .theia-ControlPanel {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  margin-bottom: 0px;\n}\n\n.dialogContent .theia-ControlPanel > * {\n  margin-left: 4px;\n}\n\n.dialogContent .theia-ToggleHiddenInputContainer {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding-top: var(--theia-ui-padding);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
